var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ThemeContext, ThemeProvider } from "styled-components";
import { Box, Caption, Link, AppBox, AppContainer, BottomContainer } from "./atoms";
import { Panel, Grid, Typography } from "../../index";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import useMedia from "use-media";

// MINI COMPS
var CountryPicker = function CountryPicker(_ref) {
  var content = _ref.content;
  return React.createElement(
    Box,
    null,
    React.createElement(
      Caption,
      null,
      content.country.caption
    ),
    content.country.countryPicker()
  );
};

var GetTheApp = function GetTheApp(_ref2) {
  var content = _ref2.content;
  return React.createElement(
    Box,
    null,
    React.createElement(
      Caption,
      null,
      content.getTheApp.caption
    ),
    React.createElement(
      AppContainer,
      null,
      React.createElement(AppBox, {
        href: content.getTheApp.linkApple,
        target: "blank",
        icon: React.createElement(FaApple, null),
        textTop: content.getTheApp.copyApple,
        textBottom: "App Store"
      }),
      React.createElement(AppBox, {
        href: content.getTheApp.linkGoogle,
        target: "blank",
        icon: React.createElement(FaGooglePlay, null),
        textTop: content.getTheApp.copyGoogle,
        textBottom: "Google Play"
      })
    )
  );
};

var CostExample = function CostExample(_ref3) {
  var content = _ref3.content;
  return React.createElement(
    Box,
    null,
    React.createElement(
      Caption,
      null,
      content.disclaimer.caption
    ),
    React.createElement(
      Typography,
      { size: 1, color: "coreGrey" },
      content.disclaimer.copy
    )
  );
};

var LinkSwitcher = function LinkSwitcher(_ref4) {
  var item = _ref4.item,
      restProps = _objectWithoutProperties(_ref4, ["item"]);

  if (item.link.match(/^https?/)) {
    return React.createElement(
      Link,
      _extends({ href: item.link, rel: "noopener noreferrer" }, restProps),
      item.text
    );
  } else {
    return React.createElement(
      Link,
      _extends({ href: item.link }, restProps),
      item.text
    );
  }
};

// MAIN EXPORT
var Footer = function Footer(_ref5) {
  var content = _ref5.content,
      social = _ref5.social,
      restProps = _objectWithoutProperties(_ref5, ["content", "social"]);

  var theme = useContext(ThemeContext);
  var isMobile = useMedia({
    maxWidth: theme.breakpointsRaw[1]
  });

  return React.createElement(
    ThemeProvider,
    {
      theme: {
        //   ...theme.altThemes.inverted,
        // background: theme.colors.coreNavy
      }
    },
    React.createElement(
      React.Fragment,
      null,
      React.createElement(
        Panel,
        { background: true, mt: 2.5, mb: 0.5 },
        isMobile && React.createElement(CountryPicker, { content: content }),
        React.createElement(
          Grid,
          { gap: true },
          content.links.map(function (link, i) {
            return React.createElement(
              Grid.Box,
              { key: i, width: [1 / 2, 1 / 2, 2 / 12] },
              React.createElement(
                Box,
                null,
                React.createElement(
                  Caption,
                  null,
                  link.caption
                ),
                link.items.map(function (item, i) {
                  return React.createElement(LinkSwitcher, { item: item, key: i });
                })
              )
            );
          }),
          React.createElement(Grid.Box, { width: [1, 1, 2 / 12], hide: [true, true, false] }),
          React.createElement(
            Grid.Box,
            { width: [1, 1, 4 / 12] },
            !isMobile && React.createElement(CountryPicker, { content: content }),
            content && content.getTheApp ? React.createElement(GetTheApp, { content: content }) : null,
            content && content.disclaimer ? React.createElement(CostExample, { content: content }) : null
          )
        )
      ),
      React.createElement(
        ThemeProvider,
        { theme: { background: theme.colors.ultraLightGrey } },
        React.createElement(
          Panel,
          { mt: 1.5, mb: 0.75, background: true },
          React.createElement(
            BottomContainer,
            null,
            content.bottom.links.map(function (item, i) {
              return React.createElement(
                Grid.Box,
                { key: i, width: [1, 1, 0] },
                React.createElement(LinkSwitcher, { item: item, size: 0.875 })
              );
            }),
            React.createElement(
              Grid.Box,
              { width: 1, style: { flex: 1 } },
              React.createElement(
                Typography,
                { size: 0.875, gutterBottom: true },
                content.bottom.copy
              )
            )
          )
        )
      )
    )
  );
};

export { Footer };
Footer.propTypes = process.env.NODE_ENV !== "production" ? {
  content: PropTypes.object
} : {};